import { unstable_useEventCallback as useEventCallback } from '@material-ui/utils';
export default useEventCallback;